import ErrorText from "app/components/form/error-text";
import classNames from "classnames";
import { Field, useFormikContext } from "formik";
import PropTypes from "prop-types";

export const RadioGroup = ({ name, label, children }) => {
  return (
    <div>
      {label ? (
        <p className="mb-5 text-sm font-extrabold leading-5">{label}</p>
      ) : null}
      {children}
      <div className="mt-4">
        <ErrorText name={name} />
      </div>
    </div>
  );
};

export const Radio = ({ name, label, value, onChange, className, checked }) => {
  const { handleChange } = useFormikContext();

  return (
    <label className={classNames("flex items-center gap-3", className)}>
      <Field
        type="radio"
        name={name}
        value={value}
        onChange={(value) => {
          handleChange(value);
          onChange?.(value);
        }}
        className="accent-primary"
        checked={checked}
      />
      <span className="text-sm font-medium leading-5">{label}</span>
    </label>
  );
};

RadioGroup.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
};
Radio.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  checked: PropTypes.bool,
};
